import { render, staticRenderFns } from "./inputTabKerja.vue?vue&type=template&id=ed25f1e4"
import script from "./inputTabKerja.vue?vue&type=script&lang=js"
export * from "./inputTabKerja.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports